import React, { createContext, useState } from 'react'

import { MasaAccount } from '../../models'

export const AccountsContext = createContext({} as AccountsContextValues)

export interface AccountsContextProviderProps {
    children: React.ReactNode
}

export interface AccountsContextValues {
    selectedAccount: MasaAccount | null
    setSelectedAccount: React.Dispatch<React.SetStateAction<MasaAccount | null>>
}

export function AccountsContextProvider({
    children,
}: AccountsContextProviderProps) {
    const [selectedAccount, setSelectedAccount] = useState<MasaAccount | null>(
        null,
    )

    const context: AccountsContextValues = {
        selectedAccount,
        setSelectedAccount,
    }

    return (
        <AccountsContext.Provider value={context}>
            {children}
        </AccountsContext.Provider>
    )
}
